import { createActions } from 'redux-actions';

export default createActions({
  SHOW_PANE: undefined,
  HIDE_PANE: undefined,
  HIDE_ALL_PANES: undefined,
});
